export interface FaqPageJsonLdItem {
  /** Answer rich text already flattened to plain text (app layer's concern). */
  answerPlainText: string;
  question: string;
}

export interface FaqPageJsonLd {
  '@context': 'https://schema.org';
  '@type': 'FAQPage';
  mainEntity: FaqPageQuestion[];
}

interface FaqPageQuestion {
  '@type': 'Question';
  acceptedAnswer: {
    '@type': 'Answer';
    text: string;
  };
  name: string;
}

/**
 * Pure schema.org FAQPage builder (BRLYAH-15). Pairs missing either side are
 * dropped — schema.org requires both `name` and `acceptedAnswer.text`.
 * Returns null when nothing remains so callers can omit the script tag.
 * Values are NOT escaped here; escaping belongs to the serializer (BaseHead).
 */
export const buildFaqPageJsonLd = (items: ReadonlyArray<FaqPageJsonLdItem>): FaqPageJsonLd | null => {
  const mainEntity = items
    .filter(item => item.question.trim() && item.answerPlainText.trim())
    .map(
      (item): FaqPageQuestion => ({
        '@type': 'Question',
        acceptedAnswer: { '@type': 'Answer', text: item.answerPlainText },
        name: item.question,
      }),
    );

  if (mainEntity.length === 0) {
    return null;
  }

  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity,
  };
};
